import Backbone from 'backbone';
import $ from 'jquery';

class ProfileView extends Backbone.View<Backbone.Model> {
  static initClass(): void {
    this.prototype.el = '#profile';
    // @ts-expect-error
    this.prototype.events = {'click .nav-tabs a': 'handleTabClick'};
  }

  initialize(): void {
    $(window).on('hashchange.profileview', () => this.setTabFromHash());
  }

  remove(): Backbone.View<Backbone.Model> {
    $(window).off('.profileview');
    return super.remove();
  }

  handleTabClick(e: Event): void {
    const target = e.currentTarget as HTMLAnchorElement;
    const href = target.getAttribute('href');
    if (href) {
      window.location.hash = href.substring(1);
    }
  }

  setTabFromHash(): this {
    let $tab = this.$('.nav-tabs a').filter(function () {
      // @ts-expect-error
      return $(this).attr('href') === window.location.hash;
    });
    if ($tab.length === 0) {
      $tab = this.$('.nav-tabs a:eq(0)');
    }
    $tab.tab('show');
    return this;
  }
}
ProfileView.initClass();

export default ProfileView;
